import { ChevronLeft, Send } from 'lucide-react';
import { useSupport } from '../../../../../../context/support/SupportContext';
import CustomInput from '../../../../../../components/forms/CustomInput';
import VisualEvidencePicker from './sections/VisualEvidencePicker';

const NewTicketForm = () => {
  const {
    agentData,
    issue,
    setIssue,
    isSubmitting,
    handleSubmitTicket,
    handleBackToTicketList
  } = useSupport();

  return (
    <div className="flex-1 overflow-y-auto p-4 md:p-12 bg-white">
      <div className="max-w-xl mx-auto space-y-6">
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={handleBackToTicketList}
            className="md:hidden p-1 -ml-1 text-gray-500 hover:bg-gray-100 rounded-full cursor-pointer"
          >
            <ChevronLeft size={24} />
          </button>
          <div>
            <h3 className="text-xl font-bold text-gray-900">New Support Ticket</h3>
            <p className="text-xs text-gray-500 font-medium tracking-tight">
              Describe your issue and Trrip admin will assist you.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmitTicket} className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <CustomInput
              label="Your Name"
              value={agentData?.name || ''}
              disabled
            />
            <CustomInput
              label="Your Email"
              value={agentData?.email || ''}
              disabled
            />
          </div>

          <div className="space-y-1">
            <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5 ml-1">
              Observation
            </label>
            <textarea
              value={issue}
              onChange={(e) => setIssue(e.target.value)}
              rows="5"
              placeholder="Describe the issue in detail..."
              disabled={isSubmitting}
              className={`w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-1 focus:ring-[#067978] focus:border-[#067978] transition-all resize-none text-sm outline-none font-medium ${
                isSubmitting ? 'bg-gray-50 opacity-50 cursor-not-allowed' : ''
              }`}
            />
          </div>

          <VisualEvidencePicker />

          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-4 rounded-xl font-black flex items-center justify-center gap-2 transition-all cursor-pointer ${
              isSubmitting
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-[#067978] text-white hover:bg-teal-700 shadow-xl shadow-teal-900/20 active:scale-[0.98]'
            }`}
          >
            {isSubmitting ? 'TRANSMITTING...' : 'OPEN CASE'}
            {!isSubmitting && <Send size={18} />}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewTicketForm;
